import { Delete } from "@mui/icons-material";
import {
  Register,
  ForgotPassword,
  Login,
  SsoLogin,
  SsoInvite,
} from "../modules/authentication";
import AuthRoute from "./auth_route";
import DeleteConfirmation from "../modules/authentication/login/DeleteConfirmation";
import ResetPassword from "../pages/userManagement/Reset_Password";
import { RegisterActivation } from "../modules/authentication/Register";
 
import Integration from "../pages/Login/Integration";

const LoginRoutes = [
  {
    path: "/",
    element: <AuthRoute />,
    children: [
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      {path:"/login/reset-password/:id/:token",element:<ResetPassword/>},
      {path:"/login/activation/:id/:token",element:<RegisterActivation/>},
      

    ],
  },
  { path: "/login/sso", element: <SsoLogin /> },
  {path: "/login/delete",element:<DeleteConfirmation/>},
  { path: "/login/sso-invite/:id/:token", element: <SsoInvite /> },
  {path:"login/integration/:integration_name/:company_uuid",element:<Integration/>},
  {}
];

export default LoginRoutes;
